import {BaseEvent} from "./BaseEvent";

export class MarkupShapeEvent extends BaseEvent {
  static GEOMETRY_CHANGED = 'markupSegmentGeometryChanged';
}